import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import foodpageLogo from "../assets/logo.png";
import logoSmall from "../assets/favsss.png";
import { jwtDecode } from "jwt-decode";
import { AppContext } from "../context/AppContext";
import "../styles/style.css";

const MasterLayout = ({ children }) => {
  const navigate = useNavigate();
  const { setAdminToken, fetchShopSettings } = useContext(AppContext);
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const [shopName, setShopName] = useState("");
  const [shopDetails, setShopDetails] = useState(null);

  useEffect(() => {
    const init = async () => {
      const token = window.localStorage.getItem("UserRetention");
      const shopName = window.sessionStorage.getItem("shopName") ?? "";

      if (token) {
        const decryptedData = jwtDecode(token);

        setShopName(decryptedData?.shopName ?? "");
        window.sessionStorage.setItem(
          "shopName",
          decryptedData?.shopName ?? ""
        );

        if (!shopDetails && decryptedData?.shopUrl) {
          await fetchShopData(decryptedData?.shopUrl);
        }
      }
    };

    init();
  }, []);

  const fetchShopData = async (shopUrl) => {
    await fetchShopSettings(shopUrl, {
      onSuccess: (res) => {
        setShopDetails(res?.data ?? null);
      },
      onFailed: (err) => {
        console.log("Error fetching shop settings:", err);
      },
    });
  };

  const userLogout = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    setAdminToken(null);
    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const currentYear = new Date().getFullYear();

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      {/* <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img src={foodpageLogo} alt="site logo" className="light-logo" />
            <img src={foodpageLogo} alt="site logo" className="dark-logo" />
            <img src={logoSmall} alt="site logo" className="logo-icon" />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <li className="dropdown">
              <li>
                <NavLink
                  to="/"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="solar:home-smile-angle-outline"
                    className="menu-icon"
                  />
                  <span>Dashboard</span>
                </NavLink>
              </li>
            </li>

            <li className="sidebar-menu-group-title">Table Reservation</li>
            <li>
              <NavLink
                to="/table-enquiry-list"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon
                  icon="material-symbols:table-bar-outline"
                  className="menu-icon"
                />
                <span>Enquiries</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/reservation-settings"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:dinner-bell" className="menu-icon" />
                <span>Reservation Settings</span>
              </NavLink>
            </li>
            <li className="sidebar-menu-group-title">Promotions</li>
            <li>
              <NavLink
                to="/promotion-list"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="material-symbols:list" className="menu-icon" />
                <span>Promotions List</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/create-promotion"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon
                  icon="material-symbols:create-new-folder-outline-rounded"
                  className="menu-icon"
                />
                <span>Create Promotions</span>
              </NavLink>
            </li>
            <li className="sidebar-menu-group-title">Events</li>
            <li>
              <NavLink
                to="/events"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:calendar-month-outline" className="menu-icon" />
                <span>Manage Events</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/create-new-event"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="mdi:calendar-edit-outline" className="menu-icon" />
                <span>Add Event</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside> */}

      <main
        className={
          sidebarActive ? "dashboard-main active" : "dashboard-main active"
        }
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between g-2 flex-nowrap">
            <div className="col min-w-0">
              <div className="d-flex align-items-center gap-2 gap-sm-3 navbar-brand-row">
                {shopDetails && shopDetails?.image && (
                  <img
                    src={shopDetails?.image ?? ""}
                    alt="Shop Logo"
                    className="shop_logo"
                  />
                )}
                {/* <Link to="/" className="sidebar-logo">
                  <img
                    src={foodpageLogo}
                    alt="site logo"
                    className="light-logo"
                  />
                  <img
                    src={foodpageLogo}
                    alt="site logo"
                    className="dark-logo"
                  />
                  <img src={logoSmall} alt="site logo" className="logo-icon" />
                </Link> */}
                {/* <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button> */}
                {/* <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button> */}
                {/* <form className="navbar-search">
                  <input type="text" name="search" placeholder="Search" />
                  <Icon icon="ion:search-outline" className="icon" />
                </form> */}
                <p className="navbar-shop-name text-danger m-0" title={shopName}>
                  <strong>{shopName}</strong>
                </p>
              </div>
            </div>

            <div className="col-auto">
              <div className="d-flex align-items-center gap-2 gap-sm-3">
                {/* ThemeToggleButton */}
                {/* <ThemeToggleButton /> */}
                <div className="dropdown d-none d-sm-inline-block">
                  {/* <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Fa.FaRegUser />
                  </button> */}
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    {/* <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-0">
                          Le Arabia
                          <p className="text-xs mb-0 pt-4">
                            Shop Admin Manager
                          </p>
                        </h6>
                      </div>
                    </div> */}
                    <div className="max-h-400-px overflow-y-auto scroll-sm pe-8">
                      <div className="form-check style-check d-flex align-items-center justify-content-between mb-16"></div>
                      {/* <div className="dropdown d-flex">
                        <button
                          className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                          type="button"
                          onClick={userLogout}
                        >
                          <Icon
                            icon="mage:logout"
                            className="text-primary-light text-xl"
                          />
                          <span className="py-2 px-3">
                            <strong>Logout</strong>
                          </span>
                        </button>
                      </div> */}
                      {/* <div className="form-check style-check d-flex align-items-center justify-content-between">
                        <label
                          className="form-check-label line-height-1 fw-medium text-secondary-light"
                          htmlFor="canada"
                        >
                          <span className="text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3">
                            <img
                              src="assets/images/flags/flag8.png"
                              alt=""
                              className="w-36-px h-36-px bg-success-subtle text-success-main rounded-circle flex-shrink-0"
                            />
                            <span className="text-md fw-semibold mb-0">
                              Canada
                            </span>
                          </span>
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="crypto"
                          id="canada"
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* Language dropdown end */}
                <div className="dropdown">
                  <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    onClick={userLogout}
                    aria-label="Logout"
                    title="Logout"
                  >
                    <Icon
                      icon="mage:logout"
                      className="text-primary-light text-xl"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            {/* <div className="col-auto">
              <p className="mb-0">
                © {currentYear} Foodpage. All Rights Reserved.
              </p>
            </div> */}
            <div className="col-12 col-sm-auto">
              <Link
                to="https://foodpage.co.uk/"
                className="sidebar-logo d-footer-brand d-flex gap-2 align-items-center"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fw-bold d-footer-powered">Powered by</span>
                <img
                  src={foodpageLogo}
                  alt="site logo"
                  className="light-logo"
                />
                <img src={foodpageLogo} alt="site logo" className="dark-logo" />
                <img src={logoSmall} alt="site logo" className="logo-icon" />
              </Link>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
